// extracted by mini-css-extract-plugin
module.exports = {"navigation":"Navigation_navigation__1VtLy","logo":"Navigation_logo__2YMz7","content":"Navigation_content__3oLqh","navItems":"Navigation_navItems__2nkdZ"};